import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type SuggestedAdvancePaymentAmountInput = {
  centerId: number
}

type SuggestedAdvancePaymentAmountResponse = {
  amount: number
}

export function getSuggestedAdvancePaymentAmount(input: SuggestedAdvancePaymentAmountInput) {
  return restApiClient
    .url(
      encodeNestedObject<SuggestedAdvancePaymentAmountInput>(
        API.centerOlPayments.getSuggestedAdvanceAmount.url,
        input
      )
    )
    .get<SuggestedAdvancePaymentAmountResponse>()
}
